/* eslint-disable import/prefer-default-export */

import { PRICEBOOK } from "../../../constants";

// Destructuring
const { QUANTITY_UOM_BLANK_OPTION } = PRICEBOOK;

// Custom JSON manipulator for screen 2
export const manipulateCustomJSONTwo = (
  customJSON,
  formRowData,
  fieldMapIndex,
) => {
  const customJSONClone = customJSON.map(item => item);

  // code to update list price label
  customJSONClone.find(item => item.name === "price").label = `List Price / ${
    formRowData[fieldMapIndex.uom]
  } ${
    formRowData[fieldMapIndex.quantity_uom] &&
    formRowData[fieldMapIndex.quantity_uom] !== QUANTITY_UOM_BLANK_OPTION
      ? `/ ${formRowData[fieldMapIndex.quantity_uom]}`
      : ""
  }`;
  return customJSON;
};



// WEBPACK FOOTER //
// ./src/components/Pricebook/FlatPriceEditor/methods.js